import axios, { type Method } from 'axios';

export const HttpMethods = {
  GET: 'GET',
  DELETE: 'DELETE',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  OPTIONS: 'OPTIONS',
} as const satisfies Record<string, Method>;

export const baseUrl = {
  SHARED: '/v0/shared',
  APP: '/app/v0/api',
  OS: '/v0/os',
  TERMINAL: '/v0/terminal',
  SHERPA: '/v0/terminal/sherpa',
  ROVER: '/v0/rover',
  SABACUS: '',
  VENDOR: '',
};

//Below instance does not work properly with session auth
//Backend needs to change to support below instance
export const appAxios = axios.create({
  baseURL: baseUrl.APP,
});

export const sherpaAxios = axios.create({
  baseURL: baseUrl.SHERPA,
});

export const roverAxios = axios.create({
  baseURL: baseUrl.ROVER,
});

export const sabacusAxios = axios.create({
  baseURL: baseUrl.SABACUS,
});
